module.exports = __webpack_public_path__ + "img/ep-chat.5d5c09dd.jpg";